import React, { FunctionComponent, ReactNode } from 'react'
import HeadWithSubhead from '@/app/_components/HeadWithSubhead/HeadWithSubhead'
import DateTimeHeader from '@/app/_components/DateTimeHeader/DateTimeHeader'
import MembershipPerks from '@/app/_components/MembershipPerks/MembershipPerks'
import CouponContainer from '@/app/_components/CouponContainer/CouponContainer'
import LocationWithAddress from '@/app/_components/LocationWithAddress/LocationWithAddress'
import { OrderSummaryRenderContext } from '@/types/order-summary.types'
import TXT from '@/messages'

type Props = {
  entryTime: string | null
  endTime: string | null
  entryDate: string
  isEvent?: boolean
  renderContext: OrderSummaryRenderContext
  venue?: Transformed.Venue[]
  testIdVariant?: 'purchase' | 'order'
  displayMembershipPerks?: boolean,
}

const OrderSummaryHeader: FunctionComponent<Props> = ({
  entryTime,
  endTime,
  entryDate: date,
  isEvent = false,
  renderContext,
  venue = undefined,
  testIdVariant = 'order',
  displayMembershipPerks = false,
}: Props): ReactNode => {
  const {
    admissionType,
    cityName,
    isPreview,
    displayMembership,
    exhibitionName,
    showCoupons,
    timezone,
  } = renderContext

  return (
    <section data-testid={`${testIdVariant}-summary-header`}>
      {/**
       * For Events, we would use event metadata & Venue for the <LocationWithAddress /> component
       * As we are not displaying this block on events, using just the Venue is fine
       */}
      {!isEvent && (
        <>
          <HeadWithSubhead head={exhibitionName} subhead={`${TXT.mw} ${cityName}`} />
          {/* Membership Perks */}
          {displayMembershipPerks && (
            <MembershipPerks />
          )}
          <DateTimeHeader
            admissionType={admissionType}
            entryTime={entryTime}
            endTime={endTime}
            date={date}
            displayMembership={displayMembership}
            timezone={timezone}
          />
          {venue?.[0] && <LocationWithAddress title={venue[0].title} address={venue[0].address} />}
        </>
      )}
      {showCoupons && !isPreview && <CouponContainer />}
    </section>
  )
}
export default OrderSummaryHeader
